import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { addOneAnnouncementToStore } from 'store/actions/announcement';
import { Button } from 'app/shared/button';
import { SimpleInput } from 'app/shared/input';
import { useAnnouncementService } from 'hooks/api/iam/announcement';
import { ImageUploadField } from '../image-upload';

const AddAnnouncement = ({ closeModal = () => {} }) => {
  const dispatch = useDispatch();
  const { createAnnouncement } = useAnnouncementService();

  const [image_url, setImageUrl] = useState('');
  const [url, setUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const clearForm = () => {
    setImageUrl('');
    setUrl('');
  };

  const submit = async () => {
    if (!image_url) {
      toast.error('Image URL is required.');
      return;
    }

    setLoading(true);
    const payload = await createAnnouncement({ image_url, url: url || null });
    setLoading(false);

    if (!payload) return;

    dispatch(addOneAnnouncementToStore(payload));
    clearForm();
    closeModal();
  };

  return (
    <div>
      <ImageUploadField value={image_url} onChange={setImageUrl} />
      <SimpleInput
        label="Target URL"
        placeholder="https://example.com"
        value={url}
        onInput={setUrl}
      />
      <Button
        icon_name="add"
        text="Save"
        onClick={submit}
        className="float-right w-25 mt-4 mb-4"
        loading={loading}
      />
      <Button
        text="Cancel"
        type="secondary"
        onClick={closeModal}
        className="float-right w-25 mt-4 mb-4 mr-4"
        loading={loading}
      />
    </div>
  );
};

export default AddAnnouncement;
